import React, { useRef, useState } from 'react';

import { VideoWidgetProps } from './videoWidgetProps';

import ReactPlayer from 'react-player/lazy';
import Icon from '../../../ui/icon/icon';

//@ts-ignore
import variables from '../../../../common/styles/globalColors.module.scss';

import './videoWidget.scss';

const VideoWidget: React.FC<VideoWidgetProps> = ({ videoSrc, title }) => {
  const videoRef = useRef(null);
  const [modalMode, setModalMode] = useState<boolean>(false);

  const playVideo = () => {
    setModalMode(true);
  };

  const closeVideo = () => {
    videoRef.current.showPreview();
    setModalMode(false);
  };

  return (
    <div className='video-widget-wrapper'>
      <div className='video-widget-title'>{title}</div>
      <div className={`${modalMode ? 'modal-mode-container' : 'not-modal-mode-container'}`}>
        {modalMode && <Icon name='fas fa-xmark' className='close-video-icon pointer' onClick={closeVideo} />}
        <ReactPlayer
          ref={videoRef}
          className='react-player'
          url={videoSrc}
          width='100%'
          playIcon={<button className='custom-play-icon pointer'><Icon name='fas fa-play' /></button>}
          // we can even specify our custom background image when it's in light mode
          light
          onClickPreview={playVideo}
          controls
          config={{
            vimeo: {
              title: title,
              playerOptions: {
                title: false,
                color: variables.primaryColor.substring(1),
                vimeo_logo: false,
                transcript: false,
                portrait: false,
                interactive_markers: 0,
              },
            },
          }}
        />
      </div>
    </div>
  );
};
export default VideoWidget;